// Chaarmology Tribe — lightbox controller.
// Hardcoded album data lives in window.__tribeAlbums (set in the section
// Liquid via {{ ... | json }}). Phase B (Task 18) replaces the sample data
// with real metaobject content; this file does not change.
(function () {
  const lb = document.getElementById('cm-tribe-lb');
  if (!lb) return;
  const elMain  = document.getElementById('cm-tribe-lb-main');
  const elName  = document.getElementById('cm-tribe-lb-name');
  const elPos   = document.getElementById('cm-tribe-lb-pos');
  const elClose = lb.querySelector('.cm-tribe-lb__close');
  const albums  = window.__tribeAlbums || {};

  let activeHandle = null;
  let activeIndex  = 0;

  function open(handle, index) {
    const a = albums[handle];
    if (!a) return;
    activeHandle = handle;
    activeIndex = Math.max(0, Math.min(index, a.photos.length - 1));
    renderActive();
    lb.hidden = false;
    document.body.classList.add('cm-tribe-lb-open');
  }
  function close() {
    lb.hidden = true;
    document.body.classList.remove('cm-tribe-lb-open');
    activeHandle = null;
  }
  function renderActive() {
    const a = albums[activeHandle];
    if (!a) return;
    elMain.src = a.photos[activeIndex];
    elMain.alt = a.name + ' — photo ' + (activeIndex + 1);
    elName.textContent = a.name;
    elPos.textContent = String(activeIndex + 1).padStart(2, '0') + ' / ' + String(a.photos.length).padStart(2, '0');
    // Thumbnails
    const strip = document.getElementById('cm-tribe-lb-thumbs');
    strip.innerHTML = a.photos.map((src, i) =>
      `<button type="button" class="cm-tribe-lb__thumb${i === activeIndex ? ' is-active' : ''}" data-i="${i}" aria-label="Photo ${i + 1}"><img src="${src}" alt=""></button>`
    ).join('');
    strip.querySelectorAll('.cm-tribe-lb__thumb').forEach(t => {
      t.addEventListener('click', () => {
        activeIndex = parseInt(t.dataset.i, 10);
        renderActive();
        t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  // Tile click → open
  document.querySelectorAll('.cm-tribe-tile').forEach(tile => {
    tile.addEventListener('click', e => {
      e.preventDefault();
      open(tile.dataset.handle, 0);
    });
  });

  // Close button + backdrop click
  elClose.addEventListener('click', close);
  lb.addEventListener('click', e => { if (e.target === lb) close(); });

  function step(delta) {
    const a = albums[activeHandle];
    if (!a) return;
    activeIndex = (activeIndex + delta + a.photos.length) % a.photos.length;
    renderActive();
  }
  lb.querySelector('.cm-tribe-lb__arr--prev').addEventListener('click', () => step(-1));
  lb.querySelector('.cm-tribe-lb__arr--next').addEventListener('click', () => step(+1));

  // Focus management — remember the trigger so we can restore on close.
  let trigger = null;
  document.querySelectorAll('.cm-tribe-tile').forEach(tile => {
    tile.addEventListener('click', () => { trigger = tile; });
  });

  // Keyboard
  document.addEventListener('keydown', e => {
    if (lb.hidden) return;
    if (e.key === 'Escape')      { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft')  { e.preventDefault(); step(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(+1); }
    else if (e.key === 'Tab') {
      // Simple focus trap — keep Tab inside the lightbox
      const focusables = lb.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Focus the close button when the lightbox opens; restore on close.
  const _open  = open;  open  = function (h, i) { _open(h, i);  elClose.focus(); };
  const _close = close; close = function ()   { _close();      if (trigger) trigger.focus(); };

  function syncHash() {
    if (activeHandle === null) {
      if (location.hash.startsWith('#tribe/')) history.replaceState(null, '', location.pathname + location.search);
    } else {
      const h = '#tribe/' + activeHandle + '/' + activeIndex;
      if (location.hash !== h) history.replaceState(null, '', location.pathname + location.search + h);
    }
  }

  function readHash() {
    const m = location.hash.match(/^#tribe\/([a-z0-9-]+)\/(\d+)$/);
    if (m) open(m[1], parseInt(m[2], 10));
  }

  window.addEventListener('hashchange', () => {
    if (!location.hash.startsWith('#tribe/') && !lb.hidden) close();
    else readHash();
  });

  // On first load, open the lightbox if the hash already points to a member.
  if (location.hash.startsWith('#tribe/')) readHash();

  // Patch syncHash into open / close / step
  const _renderActive = renderActive;
  renderActive = function () { _renderActive(); syncHash(); };

  // Swipe navigation (mobile) — only triggers within the .cm-tribe-lb__stage.
  let touchX = null;
  const stage = lb.querySelector('.cm-tribe-lb__stage');
  stage.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend',   e => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50) step(dx < 0 ? +1 : -1);
  }, { passive: true });

  // Preload the adjacent photos whenever renderActive runs, so prev/next is instant.
  const _renderActiveForPreload = renderActive;
  renderActive = function () {
    _renderActiveForPreload();
    const a = albums[activeHandle];
    if (!a || a.photos.length < 2) return;
    const n = a.photos.length;
    new Image().src = a.photos[(activeIndex + 1) % n];
    new Image().src = a.photos[(activeIndex - 1 + n) % n];
  };

  // Expose for the later tasks
  window.__tribeLightbox = { open, close, renderActive,
    get index() { return activeIndex; },
    set index(i) { activeIndex = i; renderActive(); },
    get handle() { return activeHandle; } };
})();
